import React from 'react';

import { styled } from '@mui/material/styles';
import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import IconPanelSeeding from 'common/components/icons/IconPanelSeeding';

const StyledIcon = styled(IconPanelSeeding)`
    @media (max-width: 768px) {
        width: 20px;
        height: 20px;
    }
`;

const StyledText = styled(Typography)`
    display: block;
    font-size: 25px;
    font-style: normal;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 0;
    margin-left: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const TitlePreview = ({ name }) => {
    if (!name) return null;
    return (
        <Box display="flex" alignItems="center">
            <StyledIcon />
            <StyledText>{name}</StyledText>
        </Box>
    );
};

TitlePreview.propTypes = {
    name: PropTypes.string,
};

export default TitlePreview;
